const digest = 'cfc518e864d6bd57a306f689327f76849687de896280bff6f12147cf306c6a4c';
const css = `._dividerFadeRight_45pb2_1{background:linear-gradient(90deg,#e0e0e0 90%,transparent)}._dividerFadeLeft_45pb2_5{background:linear-gradient(270deg,#e0e0e0 90%,transparent)}._isolateFromParentLink_45pb2_9{cursor:default}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'dividerFadeRight': '_dividerFadeRight_45pb2_1', 'dividerFadeLeft': '_dividerFadeLeft_45pb2_5', 'isolateFromParentLink': '_isolateFromParentLink_45pb2_9' };
export const dividerFadeRight = '_dividerFadeRight_45pb2_1';
export const dividerFadeLeft = '_dividerFadeLeft_45pb2_5';
export const isolateFromParentLink = '_isolateFromParentLink_45pb2_9';
export { css, digest };